import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "../data/content";

const CountUp = ({ value, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {prefix}
      {n}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" id="stats" className="relative py-20 lg:py-28 border-y border-white/10 bg-charcoal-900">
    <div className="absolute inset-0 spotlight opacity-40 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-6 divide-white/10 lg:divide-x">
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="text-center lg:px-6"
          >
            <p className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-none tracking-tight text-gold-gradient">
              <CountUp value={s.value} prefix={s.prefix} suffix={s.suffix} />
            </p>
            <p className="text-cream/55 text-xs sm:text-sm mt-4 uppercase tracking-[0.15em] leading-relaxed">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
